import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20red%20and%20gold%20auspicious%20pattern%20background%20with%20clouds%20and%20dragons%2C%20abstract%20artistic%20style%2C%20warm%20textured%20surface%2C%20elegant%20composition%2C%20soft%20gradients%2C%20luxurious%20feel%2C%20ancient%20Chinese%20aesthetic%20meets%20modern%20minimalism&width=1800&height=1000&seq=kaiyun-hero-bg&orientation=landscape"
          alt="开运风水背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          让好运与您同行
        </h1>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/fengshui"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            探索开运知识
          </Link>
          <Link
            to="/category/jewelry"
            className="px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium text-sm whitespace-nowrap hover:bg-background-50/30 transition-colors cursor-pointer"
          >
            浏览开运饰品
          </Link>
        </div>
      </div>
    </section>
  );
}